import { SnackbarMessage, useSnackbar } from "notistack";
import { useCallback } from "react";

export type Notifier = (msg: SnackbarMessage) => void;

type Notifiers = {
  notifyError: Notifier;
  notifySuccess: Notifier;
  notifyWarning: Notifier;
  notifyInfo: Notifier;
};

export function useNotifyError(): Notifier {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return useCallback(
    (msg) => {
      const id = enqueueSnackbar(msg, {
        variant: "error",
        onClick: () => closeSnackbar(id),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );
}

export function useNotifySuccess(): Notifier {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return useCallback(
    (msg) => {
      const id = enqueueSnackbar(msg, {
        variant: "success",
        onClick: () => closeSnackbar(id),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );
}

export function useNotifyWarning(): Notifier {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return useCallback(
    (msg) => {
      const id = enqueueSnackbar(msg, {
        variant: "warning",
        onClick: () => closeSnackbar(id),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );
}

export function useNotifyInfo(): Notifier {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return useCallback(
    (msg) => {
      const id = enqueueSnackbar(msg, {
        variant: "info",
        onClick: () => closeSnackbar(id),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );
}

export default function useNotifiers(): Notifiers {
  const notifyError = useNotifyError();
  const notifySuccess = useNotifySuccess();
  const notifyWarning = useNotifyWarning();
  const notifyInfo = useNotifyInfo();

  return { notifyError, notifySuccess, notifyWarning, notifyInfo };
}
